export default __webpack_public_path__ + "static/media/1339-sale-lineal.bb9ee5c9.webp";